import { Component, ViewChild } from '@angular/core'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { AutoAccidentReportDashboardComponent } from './auto-accident-report-dashboard.component'
import { AutoAccidentReportsComponent } from './auto-accident-reports.component'

@Component({
    selector: 'app-auto-accident-report-page',
    templateUrl: './auto-accident-report-page.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        AutoAccidentReportDashboardComponent,
        AutoAccidentReportsComponent,
    ],
})
export class AutoAccidentReportPageComponent extends BaseComponent {
    @ViewChild(AutoAccidentReportDashboardComponent)
    dashboard?: AutoAccidentReportDashboardComponent

    activeTab = 0

    constructor() {
        super()
        this.activeTab = this.canViewDashboard ? 0 : 1
        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) {
            this.dashboard?.refresh()
        }
    }

    get canViewDashboard() {
        return this.services.authentication.hasFeature([FeatureType.SafetyAutoAccidentReportDashboardView])
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }
}
